import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getCateringServicesMasterList_action, insertUpdateCateringServicesMaster_action, deleteCateringServicesMaster_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/catering_services_master_action'
import { fill_action } from '../../../../../actions/fillCombo_action'
import { BASE_URL, countryActionId, toastError, toastSuccess, visaIdTypeActionId } from "../../../../../utils/constants";
import { emailValidator, mobileNoValidator } from "../../../../../utils/Validator";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import Resizer from "react-image-file-resizer";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import Passport_Front_1008_VIS_903747 from "../../../../../files/Passport_Front_1008_VIS_903747.jpeg"

class CateringServicesMasterAU extends Component {

    // initialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            Name: '',
            Address: '',
            Phone: '',
            Mobile: '',
            Fax: '',
            PrimaryEmail: '',
            SecondaryEmail: '',
            companyName: '',
            img: '',
            imgName: '',
            imgType: '',
            imgPath: '',
            CateringServicesContactPersonID: null,
            is_edit: false,
            NameErr: "",
            AddressErr: "",
            MobileErr: '',
            PrimaryEmailErr: '',
            SecondaryEmailErr: '',
            companyNameErr: '',
            imgErr: '',
        }
        this.OnCancel = this.OnCancel.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.openPdfFile = this.openPdfFile.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.ClearValue = this.ClearValue.bind(this)
        // this.handleUpdate = this.handleUpdate.bind(this)
        // this.getDetails = this.getDetails.bind(this)
        // this.emailValidation = this.emailValidation.bind(this)
        // this.onCrossClick = this.onCrossClick.bind(this)
        // this.mobileValidation = this.mobileValidation.bind(this)
        // this.onDocDelete = this.onDocDelete.bind(this)
        // this.handleDelete = this.handleDelete.bind(this)
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.is_edit) {
            const { data } = this.props.location.state;
            this.setState({
                is_edit: true,
                Name: data.Name || '',
                Address: data.Address || '',
                Phone: data.Phone || '',
                Mobile: data.Mobile || '',
                Fax: data.Fax || '',
                PrimaryEmail: data.PrimaryEmail || '',
                SecondaryEmail: data.SecondaryEmail || '',
                companyName: data.CompanyName || '',
                CateringServicesContactPersonID: data.CateringServicesContactPersonID,
                img: data.img,
                imgName: data.img,
                imgPath: data.CateringImage
            });
        }
    }

    // On cancel Click
    OnCancel() {
        this.props.navigate('/cateringServicesMasterList')
    }
    // Input Fields Validation
    inputValidate() {
        const { Name, Mobile, PrimaryEmail, SecondaryEmail, companyName, img } = this.state
        let isError = false;
        if (Name === "") {
            this.setState({ NameErr: "Please Enter Name" })
            isError = true;
        }
        if (Mobile === "") {
            this.setState({ MobileErr: "Please Enter Mobile No." })
            isError = true;
        }
        if (companyName === "") {
            this.setState({ companyNameErr: "Please Enter Company Name" })
            isError = true;
        }
        if (img === "") {
            this.setState({ imgErr: "Please Select Image" })
            isError = true;
        }
        if (PrimaryEmail === "") {
            this.setState({ PrimaryEmailErr: "Please Enter Primary Email" })
            isError = true;
        } else {
            var PEmailerr = (emailValidator(PrimaryEmail) === '') ? false : emailValidator(PrimaryEmail)
            if (PEmailerr) {
                this.setState({ PrimaryEmailErr: "Please Enter Proper Primary Email" })
                isError = true;
            }
        }
        if (SecondaryEmail !== "" && SecondaryEmail !== null) {
            var SEmailerr = (emailValidator(SecondaryEmail) === '') ? false : emailValidator(SecondaryEmail)
            if (SEmailerr) {
                this.setState({ SecondaryEmailErr: "Please Enter Proper Secondary Email" })
                isError = true;
            }
        }
        return isError;
    }

    handleSave() {
        const { Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail, companyName, img, imgType, imgPath, CateringServicesContactPersonID, is_edit } = this.state;
        if (this.inputValidate()) {
            toastError('Please enter mandatory fields');
            return;
        }
        const list = [{
            Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail, companyName, img, imgType, imgPath, CateringServicesContactPersonID
        }];
        this.setState({ isLoading: true })
        this.props.insertUpdateCateringServicesMaster_action(list)
            .then((data) => {
                if (data.error !== 1) {
                    toastSuccess(is_edit ? "Record Updated Successfully" : "Record Added Successfully")
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                        this.props.navigate('/cateringServicesMasterList')
                    }, 300);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    ClearValue() {
        this.setState({
            Name: '',
            Address: '',
            Phone: '',
            Mobile: '',
            Fax: '',
            PrimaryEmail: '',
            SecondaryEmail: '',
            companyName: '',
            img: '',
            imgName: '',
            imgType: '',
            imgPath: '',
            is_edit: false,
            CateringServicesContactPersonID: null
        })
        document.getElementById(`path`).value = ""
    }
    onFilePick = async (e, file) => {
        e.preventDefault()
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                if (file[0]['name'].toString().toLowerCase().endsWith('.pdf')) {
                    let pdfBase64 = await this.onPdfSelect(file[0]);
                    this.setState({ img: pdfBase64, imgName: file[0]['name'], imgErr: '', imgType: 'pdf' })
                } else {
                    toastError('Only .pdf files are allowed')
                }
            }
        }
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    openPdfFile(base64String, fileName) {
        const mimeType = "application/pdf";
        const byteCharacters = atob(base64String.split(",")[1]);
        const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        const fileURL = URL.createObjectURL(blob);
        const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
        if (newTab) {
            newTab.document.title = fileName;
        }
        setTimeout(() => URL.revokeObjectURL(fileURL), 500);
    }

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onCrossClick() {
        this.setState({ img: '', imgName: '', imgType: '' })
    }
    render() {
        const { Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail, img, imgName, companyName, NameErr, MobileErr, PrimaryEmailErr, SecondaryEmailErr, companyNameErr, imgErr, isLoading, is_edit,imgPath } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                               <h6 className="mb-0 p-2 text-white">Catering Services Master</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2 pt-0">

                                    <div
                                        className="card-header p-2"
                                        style={{ paddingLeft: "7px !important" }}
                                    >
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Agency contact
                                        </h3>
                                    </div>
                                    <div className="card-body p-2 mt-1">
                                        <div className="row">
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Name<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={Name}
                                                    onChange={(e) => this.setState({ Name: e.target.value, NameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{NameErr}</span>}

                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Mobile No.<span className="text-red">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    placeholder="Use / to separate multiple numbers"
                                                    value={Mobile}
                                                    onChange={(e) => this.setState({ Mobile: e.target.value, MobileErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{MobileErr}</span>}

                                            </div>
                                            <div className="col-xl-6">
                                                <label htmlFor="validationCustom03">
                                                    Address
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={Address}
                                                    onChange={(e) => this.setState({ Address: e.target.value, AddressErr: '' })}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Telephone
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    placeholder="Use / to separate multiple numbers"
                                                    value={Phone}
                                                    onChange={(e) => this.setState({ Phone: e.target.value, })}
                                                />
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">
                                                    Fax
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={Fax}
                                                    onChange={(e) => this.setState({ Fax: e.target.value, })}
                                                />
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">Primary Email<span className="text-red">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={PrimaryEmail}
                                                    onChange={(e) => this.setState({ PrimaryEmail: e.target.value, PrimaryEmailErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{PrimaryEmailErr}</span>}
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="validationCustom03">Secondary Email</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    value={SecondaryEmail}
                                                    onChange={(e) => this.setState({ SecondaryEmail: e.target.value, SecondaryEmailErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{SecondaryEmailErr}</span>}
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Company Name<span className="text-red">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="validationCustom03"
                                                        required=""
                                                        value={companyName}
                                                        onChange={(e) => this.setState({ companyName: e.target.value, companyNameErr: '' })}
                                                    />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{companyNameErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Catering Service File<span className="text-red">*</span></label>
                                                    <div className="box text-left">
                                                        <div className="js--image-preview" />
                                                        {img !== "" ? (
                                                            <div
                                                                style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    padding: "5px 16px",
                                                                    margin: "10px 0",
                                                                    borderRadius: "20px",
                                                                    backgroundColor: "#f0f0f0",
                                                                    gap: "12px",
                                                                    position: "relative",
                                                                    border: "1px solid #ddd"
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        fontSize: "14px",
                                                                    }}
                                                                    className="text-aqua"
                                                                    onClick={() => {
                                                                        if (imgPath && !img.startsWith('data:')) {
                                                                            window.open(BASE_URL.split("/api")[0] + imgPath, "_blank");
                                                                        } else {
                                                                            this.openPdfFile(img, imgName);
                                                                        }
                                                                    }}
                                                                >
                                                                    {imgName}
                                                                </span>
                                                                <span
                                                                    role="button"
                                                                    aria-label="Remove file"
                                                                    style={{
                                                                        color: "#d32f2f",
                                                                        fontSize: "20px",
                                                                        fontWeight: "bold",
                                                                        cursor: "pointer",
                                                                        lineHeight: "1"
                                                                    }}
                                                                    onClick={() => this.onCrossClick()}
                                                                >
                                                                    x
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className="upload-options mt-1">
                                                                <label style={{ cursor: 'pointer' }}>
                                                                    <input
                                                                        type="file"
                                                                        id={`path`}
                                                                        className="image-upload"
                                                                        accept=".pdf"
                                                                        onChange={e => this.onFilePick(e, e.target.files)}
                                                                    />
                                                                    <span className="text-aqua" style={{ fontSize: '12px', textAlign: 'start', display: 'block' }}>
                                                                        Max 5MB | .pdf only
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{imgErr}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                <div className="p-2 save-can d-block border-top">
                                    <div className="row">
                                        <div className=" mt-2 text-end" role="group" style={{ float: 'right' }} aria-label="Basic example">
                                            <button
                                                type="button"
                                                className="btn btn-aqua"
                                                onClick={() => this.handleSave()}
                                            >
                                                {is_edit ? 'Update' : 'Add'}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-gray ms-2"
                                                onClick={() => this.OnCancel()}
                                            >
                                                Back
                                            </button>

                                            {/* <button type="button" class="btn btn-primary rounded-0">Payment Listing Page</button> */}
                                        </div>
                                    </div>
                                </div>


                        </div>
                    </div>
                </>
            </>
        )
    }
}
export default withRouter(connect(null, { getCateringServicesMasterList_action, insertUpdateCateringServicesMaster_action, deleteCateringServicesMaster_action, fill_action })(CateringServicesMasterAU))